import { render, staticRenderFns } from "./TicketRestrictionsDialog.vue?vue&type=template&id=48bc9dd2&scoped=true"
import script from "./TicketRestrictionsDialog.vue?vue&type=script&lang=js"
export * from "./TicketRestrictionsDialog.vue?vue&type=script&lang=js"
import style0 from "./TicketRestrictionsDialog.vue?vue&type=style&index=0&id=48bc9dd2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bc9dd2",
  null
  
)

export default component.exports